import {
  VisitorsCountContainer,
  Title,
  StyledVisitorsIcon,
  VisitorName,
  VisitorEmail,
  VisitorNameContainer,
  VisitorCountContainer,
  VisitorNameWithPillContainer,
} from './styles';
import React from 'react';
import { useIntl } from 'react-intl';
import { faUserGroupSimple } from '@fortawesome/pro-regular-svg-icons/faUserGroupSimple';
import { AttendeeRO, AttendeeType } from 'store/transactions/types';

interface VisitorsCountProps {
  visitors: AttendeeRO[];
}

export const VisitorsCount = ({ visitors }: VisitorsCountProps): JSX.Element => {
  const intl = useIntl();
  const visitorCount = visitors.filter(visitor => visitor.type === AttendeeType.VISITOR).length;

  return (
    <VisitorsCountContainer data-testid="visitors-count">
      <VisitorCountContainer>
        <StyledVisitorsIcon icon={faUserGroupSimple} size="sm" />
        <Title>{intl.formatMessage({ id: 'guests_count' }, { guestsCount: visitorCount })}</Title>
      </VisitorCountContainer>
      <VisitorNameContainer>
        {visitors
          .filter(visitor => visitor.type === AttendeeType.VISITOR)
          .map(visitor => {
            const visitorName =
              visitor.first_name && visitor.last_name
                ? `${visitor.first_name} ${visitor.last_name}`
                : visitor.first_name || visitor.last_name || 'John Doe';

            return (
              <VisitorNameWithPillContainer key={visitor.uuid}>
                <VisitorName>{visitorName}</VisitorName>
                {visitor.email && <VisitorEmail>{visitor.email}</VisitorEmail>}
              </VisitorNameWithPillContainer>
            );
          })}
      </VisitorNameContainer>
    </VisitorsCountContainer>
  );
};
